import { get, post, put } from './client.js'
import { useBridgeStore } from '../stores/bridge.js'
import { withFreshToken } from './tokenProvider.js'

export function bridgeParams() {
  const bridge = useBridgeStore()
  return new URLSearchParams({
    scopedToken: bridge.scopedToken ?? '',
    apiUrl: bridge.apiUrl ?? '',
    projectCode: bridge.projectCode ?? '',
    agentCode: bridge.agentCode ?? '',
  })
}

export function listSessions() {
  return withFreshToken(() => get(`/sessions?${bridgeParams()}`))
}

export function getSession(id) {
  return withFreshToken(() => get(`/sessions/${id}?${bridgeParams()}`))
}

/**
 * Rate the session: 1 (thumbs up), -1 (thumbs down), 0 (cleared).
 * Comment is only collected on thumbs down and may be empty.
 */
export function rateSession(id, rating, comment = '') {
  return put(`/sessions/${id}/rating`, { rating, comment })
}

/**
 * Create a session. Model is not supplied — the backend selects whatever
 * default model the agent profile is configured with.
 */
export function createSession(opts = {}) {
  const { agentCode = 'rpilot-ai-spa', ...rest } = opts
  // The bridge store is read inside the thunk: the backend captures this token
  // for the session's lifetime, so it must be the post-refresh value.
  return withFreshToken(() => {
    const bridge = useBridgeStore()
    const body = {
      agentCode,
      scopedToken: bridge.scopedToken,
      apiUrl: bridge.apiUrl,
      projectCode: bridge.projectCode,
      ...rest,
    }
    // Per-instance, host-supplied context describing what the user is working
    // on (e.g. selected schedule). Sent so the backend agent can prime its
    // system prompt without the user having to repeat themselves. Only included
    // when the host actually provided one.
    if (bridge.sessionContext != null) {
      body.sessionContext = bridge.sessionContext
    }
    return post('/sessions', body)
  })
}
